/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Type/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaSelect from 'DesignSystem/TysiaSelect/index'
import TysiaSelectContent from 'DesignSystem/TysiaSelect/TysiaSelectContent/index'
import TysiaSelectField from 'DesignSystem/TysiaSelect/TysiaSelectField/react'
import TysiaSelectLabel from 'DesignSystem/TysiaSelect/TysiaSelectLabel/index'



/** @type {import('Simple/types.js').View} */
export default function Type({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/ContactInfo/Phone/Phones/Content/Phone/Edit/Content/Fields/Type",
  isInvalid,
  onChange
  
}) {
let typesValueData = fromData.useDataValue({ viewPath,
context: 'types',
})
let contactMethodAssociationPhoneTypeValueData = fromData.useDataValue({ viewPath,
context: 'contact_method_association',
path: 'phone.type',
})
let contactMethodAssociationPhoneTypeIsValidData = fromData.useDataIsValid({ viewPath,
context: 'contact_method_association',
path: 'phone.type',
validate: fromValidate.text,
required: true,
})
let contactMethodAssociationPhoneTypeChangeData = fromData.useDataChange({ viewPath,
context: 'contact_method_association',
path: 'phone.type',
})
  return (<React.Fragment
>
<TysiaSelect
  viewPath={`${viewPath}/TysiaSelect`}
 marginTop={0}
 allowEmptyChoice={false}
 data="types"
 from={typesValueData}
 data="contact_method_association.phone.type"
 validate="/Data/validate.js text"
 invalid={!contactMethodAssociationPhoneTypeIsValidData}
 required={true}
 value={contactMethodAssociationPhoneTypeValueData}
 onChange={contactMethodAssociationPhoneTypeChangeData}
>
{childProps => (
<React.Fragment>
<TysiaSelectLabel
{...childProps}
  viewPath={`${viewPath}/TysiaSelectLabel`}
 text="Type"
/>
<TysiaSelectContent
{...childProps}
  viewPath={`${viewPath}/TysiaSelectContent`}
>
{childProps => (
<TysiaSelectField
{...childProps}
  viewPath={`${viewPath}/TysiaSelectField`}
/>
)}
</TysiaSelectContent>
</React.Fragment>
)}
</TysiaSelect>
{children}
</React.Fragment>)
}